import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openDeclineModal, closeModal } from '../modules/active_modal';
import { placeEbookOrder } from '../modules/order_actions';
import { setDeclineBook } from '../modules/decline_box_book';
import { addEnrollProductToCart, addProductToCart } from '../modules/cart_actions';
import CustomBraintreeDropin  from './CustomBraintreeDropin.jsx';

import {priceOneItemCart, MAX_QUANTITY}            from '../shared/cart.js';


class LargePrintPurchase extends Component {

  constructor(props) {
    super(props);
  }

  addToCartAction(oProduct) {
    let { store, featured, activeProduct, customer, upgradeStatus, isLoggedIn, dispatch, activeFeaturedSelection, activeModal, modal } = this.props;
    if(isLoggedIn && customer.status === 'Active' && !upgradeStatus ){
      if(store.type === "Neglite" || !featured.find( x => x.id === (activeModal === "featuredSelection" ? activeFeaturedSelection.id : activeProduct.id)) || customer.current_cycle.response || !customer.current_cycle.active)
        dispatch( addProductToCart( oProduct, this.props.quantity ));
      else dispatch([
          setDeclineBook(oProduct, this.props.quantity),
          openDeclineModal(),
        ]);
    } else
      dispatch( modal && store.type === "Neglite" ?
        [addEnrollProductToCart( oProduct, this.props.quantity ), closeModal()] :
        addEnrollProductToCart( oProduct, this.props.quantity )
      );
  }


  render() {
    let {productType, product, large_print, toggleFormat, cartItems} = this.props;
    let purchaseButton = cartItems.length > 0 && cartItems.filter( c => c && c.id == product.id && c.format==='regular').length>= MAX_QUANTITY ? (
        <button
            className = "btn-primary disabled"
            name      = "book-added"
            disabled  = "true"
        >
          In Box
        </button>
    ) : (
      <button
        className = "btn-primary"
        name      = "book-added"
        onClick   = {this.addToCartAction.bind( this, {...product, format: 'regular' } )}
      >
        Add to Box
      </button>
    );
    let formatButton = (
      <div className="formatContainer">
        <div className={ "format button" + (productType === "regular" ? " active" : "")} onClick={() => toggleFormat("regular")}>
          <div className="icon">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10">
              <path fill="#231F20"
                d="M4.591,8.959c-0.155,
                0-0.308-0.047-0.438-0.137L0.672,
                6.397C0.325, 6.156,0.239,5.679,0.48,5.332
                C0.722,4.984,1.199,4.9,1.546,5.14l2.829,
                1.972L8.59,1.487c0.228-0.355,0.702-0.46,
                1.058-0.23c0.356,0.229,0.459,0.702,0.231,1.058
                L5.234,8.607C5.122,8.783,4.943,8.904,4.739,
                8.945C4.69,8.955,4.641,8.959,4.591,8.959z"
              />
            </svg>
          </div>
          <div className="text">Regular Print</div>
        </div>
        <div className={ "format button" + (productType === "large_print" ? " active" : "")} onClick={() => toggleFormat("large_print")}>
          <div className="icon">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10">
              <path fill="#231F20"
                d="M4.591,8.959c-0.155,
                0-0.308-0.047-0.438-0.137L0.672,
                6.397C0.325, 6.156,0.239,5.679,0.48,5.332
                C0.722,4.984,1.199,4.9,1.546,5.14l2.829,
                1.972L8.59,1.487c0.228-0.355,0.702-0.46,
                1.058-0.23c0.356,0.229,0.459,0.702,0.231,1.058
                L5.234,8.607C5.122,8.783,4.943,8.904,4.739,
                8.945C4.69,8.955,4.641,8.959,4.591,8.959z"
              />
            </svg>
          </div>
          <div className="text">Large Print</div>
        </div>
      </div>
    );

    if(productType === "large_print")
      purchaseButton = cartItems.length > 0 && cartItems.filter( c => c && c.id == product.id && c.format==='large_print').length >= MAX_QUANTITY ? (
        <button
            className = "btn-primary disabled"
            name      = "book-added"
            disabled  = "true"
        >
          In Box
        </button>
      ) : (
        <button
          className = "btn-primary"
          name      = "book-added"
          onClick   = {this.addToCartAction.bind( this, { ...product, format: 'large_print', sale_price: large_print.price, ...large_print } )}
        >
          Add to Box
        </button>
      );

    // case of only large_print
    if(product.visible === 0 && product.large_print)
      formatButton = (
        <div className="formatContainer">
          <div className="format button disabled" >
          <div className="icon disappear">
          </div>
            <div className="text unselected">Regular Print</div>
          </div>
          <div className="format active">
            <div className="icon">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10">
              <path fill="#231F20"
                d="M4.591,8.959c-0.155,
                0-0.308-0.047-0.438-0.137L0.672,
                6.397C0.325, 6.156,0.239,5.679,0.48,5.332
                C0.722,4.984,1.199,4.9,1.546,5.14l2.829,
                1.972L8.59,1.487c0.228-0.355,0.702-0.46,
                1.058-0.23c0.356,0.229,0.459,0.702,0.231,1.058
                L5.234,8.607C5.122,8.783,4.943,8.904,4.739,
                8.945C4.69,8.955,4.641,8.959,4.591,8.959z"
              />
            </svg>
          </div>
          <div className="text">Large Print</div>
          </div>
        </div>
      );


    return (
      <div>
        <div className="centerLine"><hr/></div>
        {formatButton}
        <div className="centerLine"><hr/></div>
        {purchaseButton}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'store': state.store,
      'featured' : state.featured,
      'customer': state.customer,
      'cartItems' : state.computedCart.items,
      'activeProduct': state.activeProduct,
      'isLoggedIn': state.isLoggedIn,
      'upgradeStatus': state.upgradeStatus,
      'activeFeaturedSelection': state.activeFeaturedSelection,
      'activeModal': state.activeModal
    };
}

export default connect(mapStateToProps)(LargePrintPurchase);



// WEBPACK FOOTER //
// ./src/components/LargePrintPurchase.jsx